import {
  Box,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
  Stack
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "~/app/store";

import {
  selectBinCircusPortStatusById,
  selectTaskGroupSize,
  setTaskGroupSize
} from "~/features/testingTools/testingTools.slice";
import { selectWorkstationAvailablePorts } from "~/redux/selectors/workstationsSelectors";

import { TASK_GROUP_SIZE_OPTIONS } from "./binToPortConstants";

const TaskGroupSizePicker = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const taskGroupSize = useAppSelector(selectTaskGroupSize);
  const ports = useAppSelector(selectWorkstationAvailablePorts);
  const portStatusesById = useAppSelector(selectBinCircusPortStatusById);
  const isTaskGroupSizeDisabled = ports.every(
    (portId) => portStatusesById[portId]?.portState === "cycling"
  );
  const onTaskGroupSizeChange = (event: SelectChangeEvent<number>) => {
    dispatch(setTaskGroupSize(Number(event.target.value)));
  };
  return (
    <Box
      sx={{
        alignSelf: "flex-end",
        mr: 5
      }}
    >
      <Stack direction="row" alignItems="center" gap={0.5}>
        <InputLabel
          sx={{ fontSize: "0.875rem", ml: 0.5, color: "text.secondary" }}
          id="task-group-size-label"
        >
          {t("bin pool size")}
        </InputLabel>
        <Typography fontSize="0.875rem" color="text.secondary">{`(${t(
          "task group size"
        )})`}</Typography>
      </Stack>

      <Select
        id="task-group-size"
        labelId="task-group-size-label"
        value={taskGroupSize}
        onChange={onTaskGroupSizeChange}
        disabled={isTaskGroupSizeDisabled}
        variant="outlined"
        fullWidth
        inputProps={{
          sx: {
            fontSize: "1.2rem",
            lineHeight: "normal",
            py: 1.5,
            px: 2
          }
        }}
        sx={{
          mt: 0.5,
          minWidth: 250
        }}
      >
        {TASK_GROUP_SIZE_OPTIONS.map((option) => (
          <MenuItem
            key={`task-group-size-${option}`}
            value={option}
            sx={{
              fontSize: "1rem"
            }}
          >
            {option}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default TaskGroupSizePicker;
